import React, { Fragment, useEffect, useContext } from 'react';
import { useHistory, useLocation  } from 'react-router-dom'
//import { withTranslation } from 'react-i18next';
import { authContext } from "../context/AuthContext";

//import { withStyles } from '@mui/material/styles';



const LoginSAML = props => {
    const history = useHistory();
    //const params = useParams();
    const { search } = useLocation();
    let query =  new URLSearchParams(search);
    const user = useContext(authContext)

    useEffect(() => {
       let token = query.get("token");
        console.log(token);
        if (token) {
            user.jwtlogin(token)
            .then(res => {
                history.push('/dashboard');
            }).catch(err => {
                //do nothing since the error message is handled globally in the App.js
                 history.push('/login');
            });
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

   
    return (
        <Fragment>
            <p>
                Successfully log in via Gatorlink    
            </p>

           
        </Fragment >
    );

}
export default LoginSAML;
